/* global L, mo, mod_tickets */

$(function(){
    setTimeout(mod_tickets.open_from_hash);
    $(window).bind('hashchange', mod_tickets.open_from_hash);

    // кнопка "добавить файл"
    $('.btn_line > a.upload', mod_tickets.$win_add_edit).click(function(event){
        event.preventDefault();
        $(this).parent().siblings('.top-uploader').topUploader().$upload_btn.click();
    });

    // кеширование введенного текста
    $('.textarea', mod_tickets.$win_add_edit).keyup(function(){
        $.cookie('9qwdf9wehdf9waeh8rf34uhf9w8df2', $(this).html());
    });
    if($.cookie('9qwdf9wehdf9waeh8rf34uhf9w8df2')) $('.textarea', mod_tickets.$win_add_edit).html($.cookie('9qwdf9wehdf9waeh8rf34uhf9w8df2'));

    // форматирование вставленного текста
    mod_tickets.$win_add_edit.on('paste', '.el .text, .textarea', function(event){
        event.preventDefault();

        var text = (event.originalEvent || event).clipboardData.getData('text/html') || '';
        if(!text) text = (event.originalEvent || event).clipboardData.getData('text/plain') || '';

        text = mod_tickets.prepare_to_edit(text);

        document.execCommand('insertHtml', false, text);
    });

    // отправка сообщения по ctrl+enter
    $('.textarea', mod_tickets.$win_add_edit).keypress(function(event){
        if((event.keyCode == 10 || event.keyCode == 13) && (event.ctrlKey || event.metaKey)){
            $(this).closest('#tickets_add, .add_form').find('.add_ticket, .edit_ticket').click();
        }
    });

    // создание тикета (открыть окно создания тикета)
    $('#top_panel').on('click', '#contextmenu_mess [rel=create]', function(){
        $('#contextmenu_mess').hide();

        var ww = $(window).width(); // ширина окна браузера
        var pw = 450; // ширина попапа
        if(ww <= pw){
            pw = ww * 0.9;
        }
        mod_tickets.$win_add.dialog({width: pw});
    });
    $('.create', mod_tickets.$tickets).click(function(event){
        event.preventDefault();

        var ww = $(window).width(); // ширина окна браузера
        var pw = 450; // ширина попапа
        if(ww <= pw){
            pw = ww * 0.9;
        }
        mod_tickets.$win_add.dialog({width: pw});
    });

    // закрытие окна создания или просмотра тикета
    mod_tickets.$win_add.on('dialogclose', function(){
        if(mod_tickets.$table && typeof(mod_tickets.$table.data('reload')) == 'function') mod_tickets.$table.data('reload')();
    });
    mod_tickets.$win_edit.on('dialogclose', function(){
        mo.setHash('open_ticket', null);
        if(mod_tickets.$table && typeof(mod_tickets.$table.data('reload')) == 'function') mod_tickets.$table.data('reload')();
    });

    var stop = false;

    // отправка нового тикета
    $('.add_ticket', mod_tickets.$win_add).click(function(event){
        event.preventDefault();

        var type = 0;
        var text = $('.textarea', mod_tickets.$win_add).html();
        text = mod_tickets.prepare_to_save(text);
        var resource = location.pathname + location.hash;

        var error = '';
        if(text.length < 10) error = L.TICKETS_Short_message;
        $('.error', mod_tickets.$win_add).text(error);
        if(error) return;

        if(stop) return;
        stop = true;

        var data = {type: type, text: text, resource: resource, oper: 'add', id: ''};

        mo.preloader();
        mo.edit(function(){
            stop = false;
            mo.preloader(false);

            $('.textarea', mod_tickets.$win_add).empty().keyup();
            $('.top-uploader', mod_tickets.$win_add).topUploader().refresh();

            mod_tickets.$win_add.dialog('close');

            $('#tickets_created').dialog({width: 400});
            if(mod_tickets.$table && mod_tickets.$table.data('reload')) mod_tickets.$table.data('reload')(); // обновить таблицу с тикетами
        }, 'mod_tickets', '', data);
    });

    // отправка тикета базе
    $('.send ', mod_tickets.$win_add_base_message).click(function(event){
        event.preventDefault();

        let type = 1;
        let text = $('textarea', mod_tickets.$win_add_base_message).val();
        text = mod_tickets.prepare_to_save(text);
        let resource = location.pathname + location.hash;

        let error = '';
        if(text.length < 10) error = L.TICKETS_Short_message;
        $('.error', mod_tickets.$win_add_base_message).text(error);
        if(error) return;

        if(stop) return;
        stop = true;

        const data = {type: type, text: text, resource: resource, base_id: base.id, oper: 'add', id: ''};

        mo.preloader();
        mo.edit(function(){
            stop = false;
            mo.preloader(false);

            $('textarea', mod_tickets.$win_add_base_message).val('');

            mod_tickets.$win_add_base_message.dialog('close');

            $('#tickets_created').dialog({width: 400});
            if(mod_tickets.$table && mod_tickets.$table.data('reload')) mod_tickets.$table.data('reload')(); // обновить таблицу с тикетами
        }, 'mod_tickets', '', data);
    });


    // отправка нового сообщения
    $('.edit_ticket', mod_tickets.$win_edit).click(function(event){
        event.preventDefault();

        var ticket_id = mod_tickets.$win_edit.data('ticket_id');
        var text = $('.textarea', mod_tickets.$win_edit).html();
        text = mod_tickets.prepare_to_save(text);

        var error = '';
        if(text.length < 5) error = L.TICKETS_Short_message;
        $('.add_form .error', mod_tickets.$win_edit).text(error);
        if(error) return;

        if(stop) return;
        stop = true;

        mo.preloader(true);
        mo.edit(function(){
            stop = false;
            mo.preloader(false);

            $('.textarea', mod_tickets.$win_edit).empty().keyup();
            $('.top-uploader', mod_tickets.$win_edit).topUploader().refresh();
            mod_tickets.open_ticket(ticket_id);
        }, 'mod_tickets', 'post', {text: text, ticket_id: ticket_id, oper: 'add', id: ''});
    });

    // кнопка обновления диалога
    $('.refresh', mod_tickets.$win_edit).click(function(event){
        event.preventDefault();

        var ticket_id = mod_tickets.$win_edit.data('ticket_id');
        mod_tickets.open_ticket(ticket_id);
    });

    // чекбокс статуса тикета (открыт/закрыт)
    mod_tickets.$win_edit.on('change', '[name=status]', function(){
        var ticket_id = mod_tickets.$win_edit.data('ticket_id');
        var status = $(this).is(':checked') * 1;
        mod_tickets.close_ticket(ticket_id, status);
    });
});

// закрыть тикет
mod_tickets.close_ticket = function(ticket_id, status){
    mo.edit(function(){
        mod_tickets.open_ticket(ticket_id);
    }, 'mod_tickets', '', {status: status, oper: 'edit', id: ticket_id});
};
